
import { Component, Mixins, Prop } from "vue-property-decorator";
import { IThickness } from "../../../../../../../domain/drawing";
import { IWizardContent, instanceOfIWizardObjectReferable } from "../../../../../../../domain/format";
import { DocumentEditableMixin, CommonComponentsAccessibleMixin } from "../../../../mixins";

@Component
export default class ContentMixin extends Mixins(DocumentEditableMixin, CommonComponentsAccessibleMixin) {
  @Prop()
  content: IWizardContent;

  @Prop({ default: false })
  disabled: boolean;

  get margin(): IThickness<string> {
    return (this.editingSource && this.content)
      ? this.content.margin
      : {
        top: "0",
        left: "0",
        bottom: "0",
        right: "0",
      };
  }

  get isMandatory(): boolean {
    return !this.disabled
        && this.editingSource
        && this.content
        && this.content.isMandatory(this.editingSource.source);
  }

  get isVisible(): boolean {
    return this.editingSource
        && this.content
        && this.content.isVisible(this.editingSource.source);
  }

  get isEnable(): boolean {
    return !this.disabled
        && this.editingSource
        && this.content
        && this.content.isEnable(this.editingSource.source);
  }

  get identifierId(): string {
    return (instanceOfIWizardObjectReferable(this.content) && !!this.content.objectIdentifier.id)
      ? this.content.objectIdentifier.id
      : "未指定";
  }
}
